<template>
    <div class="footer">
        <div class="logo-box">
            <img class="logo" src="../../public/logo.webp" alt="NEXURIAN BOOKING PRIVATE LIMITED Logo" />
            <div class="logo-text">NEXURIAN BOOKING PRIVATE LIMITED</div>
        </div>
        <div class="contact-list">
            <div class="contact" v-for="(item, index) in list" :key="index">
                <img class="item-icon" :src="item.icon" alt="">
                <div class="item-text">{{ item.title }}</div>
            </div>
        </div>
        <div class="bottom">
            © 2025 Copyright belongs to NEXURIAN BOOKING PRIVATE LIMITED
        </div>
    </div>
</template>
<script setup>
const list = [
    {
        title: 'nexurian@nexurian-booking.com',
        icon: require('../assets/footer-icon1.webp')
    },
    {
        title: '+91 6209288389',
        icon: require('../assets/footer-icon3.webp')
    },
    {
        title: 'Plot No.68B, Kavi Nagar, Rohta Road, Meerut Cantt, Meerut, Meerut- 250001, Uttar Pradesh',
        icon: require('../assets/footer-icon2.webp')
    },
]
</script>
<style lang="less" scoped>
.footer {
    width: 100%;
    background: #17263D;
    clip-path: polygon(0 10%, 100% 0, 100% 100%, 0 100%);
    padding: 0 270px;
    box-sizing: border-box;

    .logo-box {
        padding-top: 59px;
        display: flex;
        align-items: center;

        .logo {
            width: 46px;
            height: 46px;
            object-fit: cover;
            margin-right: 17px;
        }

        .logo-text {
            font-weight: bold;
            font-size: 21px;
            color: #FB7522;
            line-height: 24px;
            letter-spacing: 1px;
            text-shadow: 0px 1px 0px #333333;
        }
    }

    .contact-list {
        margin-top: 28px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 65px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);

        .contact {
            display: flex;

            .item-icon {
                width: 16px;
                height: 16px;
                object-fit: contain;
                margin-right: 8px;
            }

            .item-text {
                max-width: 330px;
                font-weight: 400;
                font-size: 14px;
                color: rgba(255, 255, 255, 0.9);
                line-height: 20px;
                text-shadow: 0px 1px 0px #333333;
            }
        }
    }

    .bottom {
        margin-top: 14px;
        font-weight: 400;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        line-height: 18px;
        text-shadow: 0px 1px 0px #333333;
        text-align: center;
        padding-bottom: 14px;
    }
}
</style>